module.exports = __webpack_public_path__ + "img/jx-0001-19-1-2.prt.17f47113.jpg";